import { memo } from 'react';
import { RecordButton } from '../RecordButton';
import { type RecordingUIProps } from './types';

export const RecordingUI = memo(function RecordingUI({
  isRecording,
  isSending,
  recordingTime,
  recordingLabel,
  onRecordClick,
}: RecordingUIProps): React.ReactElement {
  return (
    <div className="flex gap-1 justify-between w-full">
      <div className="flex items-center gap-3 border border-red-500 rounded-md p-2 w-full">
        <p className="text-sm text-red-500 animate-pulse">{recordingLabel}</p>
        <p className="text-sm text-gray-500">{recordingTime}</p>
      </div>
      <div className="flex items-center gap-2">
        <RecordButton onClick={onRecordClick} isRecording={isRecording} isSending={isSending} />
      </div>
    </div>
  );
});
